import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SettingsCtx = createContext({});

const DEFAULTS = {
  brand_name: "KOPTUR",
  brand_suffix: "®",
  legal_name: "Koptur Grup A.Ş.",
  tagline: "Yaşayan Değerler, Kalıcı Eserler",
  founded: 1993,
  logo_url: "/brand/logo.png",
  favicon_url: "/brand/favicon-64.png",
  phone: "+90 242 000 00 00",
  email: "info@koptur.com.tr",
  address: "Muratpaşa, Antalya, Türkiye",
  map_embed_url:
    "https://www.openstreetmap.org/export/embed.html?bbox=30.6900%2C36.8700%2C30.7500%2C36.9000&layer=mapnik",
  socials: { facebook: "", instagram: "", youtube: "", linkedin: "", twitter: "" },
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const s = await api.settings();
      setSettings({ ...DEFAULTS, ...s, socials: { ...DEFAULTS.socials, ...(s.socials || {}) } });
    } catch (e) {
      // keep defaults
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // Apply favicon dynamically
  useEffect(() => {
    if (!settings.favicon_url) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = settings.favicon_url;
  }, [settings.favicon_url]);

  // Update page title from brand
  useEffect(() => {
    if (settings.legal_name) {
      document.title = `${settings.legal_name} | ${settings.tagline}`;
    }
  }, [settings.legal_name, settings.tagline]);

  return (
    <SettingsCtx.Provider value={{ settings, loaded, reload: load, setSettings }}>
      {children}
    </SettingsCtx.Provider>
  );
};

export const useSettings = () => useContext(SettingsCtx);
